import { RelationshipGraphDrawer } from "../../../../shared/relationshipGraph/RelationshipGraphDrawer";

/** @const {!Object<string, string>} */
const GRAPH_NODE_TYPE_BY_ORDER_TYPE = {
  shipment: "consignment",
  purchase: "purchase_order",
};

/**
 * @param {string} orderType Board order type, e.g. "shipment" or "purchase".
 * @return {string|null} Relationship graph node type, or null when the board has no graph.
 */
export function graphNodeTypeForOrderType(orderType) {
  return GRAPH_NODE_TYPE_BY_ORDER_TYPE[orderType] || null;
}

/**
 * Board wrapper for the shared relationship graph drawer.
 */
export function BoardRelationshipGraphDrawer({
  orderType,
  isOpen,
  onClose,
  record,
  onOpenFiles,
  onOpenNotes,
}) {
  const nodeType = graphNodeTypeForOrderType(orderType);
  if (!nodeType) {
    return null;
  }
  return (
    <RelationshipGraphDrawer
      open={isOpen && Boolean(record)}
      onClose={onClose}
      anchor={record ? { type: nodeType, id: record.id, label: record.name } : null}
      onOpenFiles={onOpenFiles}
      onOpenTasks={onOpenNotes}
    />
  );
}
